import { isFieldEmpty } from "@limitless/common/utils";
import { areFieldsPristine, areAnyFieldsPristine } from "../FieldValidators";

/**
 * Validates the user inputs of the message flag feature, aka report or forward
 *
 * @param {object} fields
 */
export const validateMessageFlagFormValidator = fields => {
  const fieldErrors = {};
  const hasChanged = !areFieldsPristine(fields);
  if (!hasChanged) {
    return {
      fieldErrors,
      isFormInvalid: true
    };
  }
  const {
    code,
    body
  } = fields;
  if (!code.pristine && !code.label) {
    fieldErrors.code = "Please select a code from the list";
  }
  if (!body.pristine && isFieldEmpty(body.value)) {
    fieldErrors.body = "Please enter a description";
  }
  const isFormInvalid = Object.keys(fieldErrors).length > 0 || areAnyFieldsPristine(fields);
  return {
    fieldErrors,
    isFormInvalid
  };
};